import { Observable, throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { List } from 'immutable';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { LoggerService } from '../shared/services/logger/logger.service';
import { ProvisioningFeatures } from './provisioning-features.model';
import { AccountQuotas } from './sub-models/account-quotas.model';
import { Banner } from './sub-models/banner.model';
import { Canvas } from './sub-models/canvas.model';
import { catchError, map } from 'rxjs/operators';
import { KEYS as FEATURE_TOGGLES } from './sub-models/toggles.model';

export const PROVISIONING_ACCEPT_VERSION = '3.0.0';

@Injectable()
export class FeaturesDataService {
  private _headers: any = {
    [ACCEPT_VERSION_HEADER]: PROVISIONING_ACCEPT_VERSION,
  };

  constructor(
    private _authHttpService: AuthHttpService,
    private _loggerService: LoggerService
  ) {}

  getFeaturesData(): Observable<ProvisioningFeatures> {
    const url = '/features';
    const params = {
      feature_list: Object.keys(FEATURE_TOGGLES).join(',').toLowerCase(),
    };

    return this._authHttpService.get(url, params, this._headers).pipe(
      map(({ body, ..._ }: IResponseInfo) => new ProvisioningFeatures(body)),
      catchError((error) => observableThrowError(error))
    );
  }

  getQuotaBannersCanvases(): Observable<any[]> {
    const url = '/provisioning/quota_banners_and_canvases';

    this._loggerService.log(
      'fetching the quota banner canvases from the server'
    );

    return this._authHttpService.get(url, null, this._headers).pipe(
      map(({ body, ..._ }: IResponseInfo) => {
        const data = body['quota_banners_and_canvases'];

        return [
          new AccountQuotas(data['account_quotas']),
          List(data['banners']).map((params) => new Banner(params)),
          List(data['canvases']).map((params) => new Canvas(params)),
        ];
      }),
      catchError((error) => observableThrowError(error))
    );
  }
}
